var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 335.448h512v79.448a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 414.896v-79.448z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 88.276h494.345a8.829 8.829 0 0 1 8.828 8.828v79.448H0V97.103a8.828 8.828 0 0 1 8.828-8.827z",
    fill: "#ff4b55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M0 176.55h512v158.9H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.058 227.432l13.286 17.379 20.745-6.944c1.16-.388 2.146.924 1.452 1.93l-12.424 18.006 13.014 17.583c.727.983-.215 2.327-1.387 1.977l-20.963-6.251-12.701 17.811c-.711.996-2.28.514-2.31-.708l-.533-21.869-20.864-6.575c-1.166-.367-1.194-2.008-.04-2.415l20.634-7.264-.193-21.875c-.011-1.224 1.541-1.757 2.284-.785z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.001 298.898c-23.672 0-42.876-19.203-42.876-42.898 0-23.65 19.203-42.897 42.876-42.897 8.808 0 16.93 2.709 23.699 7.294 1.036.702 2.22-.66 1.352-1.562-10.116-10.517-24.434-16.934-40.309-16.392-27.274.93-49.852 22.797-51.594 50.031-1.996 31.194 22.703 57.118 53.455 57.118 15.148 0 28.762-6.333 38.485-16.459.858-.895-.327-2.236-1.354-1.54-6.776 4.592-14.911 7.305-23.734 7.305z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLy);
export default __webpack_public_path__ + "static/media/ly.c6772d41e787c0d68d1647b0ff10f607.svg";
export { ForwardRef as ReactComponent };